
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/

(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  
  Flits(document).on("Flits:Loaded",function(event){
    if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
      Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
    }
  });
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.global.Metafields.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  }
  Flits(window).on('load', function(event){  
    let collectionBtn = Flits('.flits-wishlist-colection');
    parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
      Flits(collectionBtn).show();
      Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
  });
  if (Flits.request.page_type != 'customers/account'){
    if (window.flitsObjects.storeData.customer_id != -1){
      Flits.getStoreCredit(function(resp){
        var current_credit = resp.customer.credits;
        var moneyFormat = Flits.money_format;
        Flits(".flits-credit-balance-span").html(Flits.formatMoney(Math.abs(current_credit), moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
        Flits(".flits-header-credit").css("display","block");
      });
    }
  }
  Flits(document).on('Flits:storeCredit:AjaxSuccessful', function(event){
    Flits(".flits-header-credit").css("display","block");
  });
  Flits(document).on('Flits:order:AllLoaded', function(event){  
    var data = event.detail; 
    if(Flits.order.settings.totalOrder > 0){
    }else{
      Flits(".flits-account-container .flits-loading-div.flits-order-loader").css("display","none");
    }
  });
  
  Flits(document).on('Flits:CartAutomaticCode:Loaded', function(event){  
    var data = event.detail;
    var cloneNode = data.cloneNode;
    var el = data.el;
    var parent= data.parent;
    Flits(parent).prepend(cloneNode);    
  });
  
  Flits("button[name='checkout']").on('click', function(event) {
    var submitBtn = this;
    return Flits.setupcheckoutProcess.apply(Flits.StoreCreditCart, [event, submitBtn]);
  });

  // Template 2 (DUO)

  if(location.pathname.indexOf("/account") != -1){
    Flits(document).on('click', '.flits-custom-tab-add', function(e){
      var elem = Flits(this).attr('href');
      elem = elem.replace('/account', '');
      var el = elem.replace('#', '');
      //     Flits('.flits-account-container').addClass('flits-active');

      Flits('.flits-menu-nav .flits-menu-item').removeClass('flits-menu-active');
      Flits('.flits-custom-tab-add').removeClass('flits-active');
      Flits('.flits-account-container a[href="'+elem+'"]').closest(".flits-menu-item").addClass("flits-menu-active")

      Flits('.flits-account-box').removeClass('flits-account-box-active');
      Flits('.flits-mobile-account-box').removeClass('flits-account-box-active');
      Flits('#flits_tab_'+el).addClass('flits-account-box-active');
      Flits('#flits_mobile_tab_'+el).addClass('flits-account-box-active');
      // To change the location.hash of the URL
      location.hash = el;
    });
  }
}(Flits));
